import { TrendingUp } from "lucide-react";
import { Panel, EmptyState } from "@/components/admin/ui";

export const PersonPerformanceTab = () => (
  <Panel title="Performance" subtitle="Metrics derived from real completed Jobs will appear here." testId="person-performance-tab">
    <EmptyState
      icon={TrendingUp}
      title="No performance data yet."
      message="Once this person completes real Jobs, metrics like completion rate and on-time performance can be calculated here — nothing is estimated or fabricated."
      testId="person-performance-empty"
    />
  </Panel>
);
